module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('modal', {
    class: ['reservation-modal', 'dark-top'],
    attrs: {
      "large": true
    },
    on: {
      "close": _vm.resetWindow
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [(!_vm.isReschedule) ? [_c('h2', [_vm._v("Select a product")])] : [_c('h2', [_vm._v("Reschedule your reservation")]), _vm._v(" "), _c('div', {
    staticClass: "radius-large p-2 bg-color-6 d-inline-block normal"
  }, [_vm._v("\n                Current reservation has ticket #" + _vm._s(_vm.getClonedReservation.id) + "\n            ")])], _vm._v(" "), _c('add-filters', {
    attrs: {
      "newReservationSetup": _vm.getNewReservationSetup,
      "paxTotal": _vm.paxTotal
    },
    on: {
      "toggleAvailability": _vm.toggleAvailability
    }
  })], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('availability', {
    attrs: {
      "opened": _vm.isOpened,
      "newReservationSetup": _vm.getNewReservationSetup
    },
    on: {
      "closeAvailability": _vm.closeAvailability
    }
  }), _vm._v(" "), (!_vm.isReschedule) ? [_c('products-scroller', {
    attrs: {
      "categories": _vm.getCategories,
      "newReservationSetup": _vm.getNewReservationSetup
    }
  })] : _vm._e(), _vm._v(" "), _c('timeline-scroller'), _vm._v(" "), _c('events', {
    attrs: {
      "isReschedule": _vm.isReschedule
    },
    on: {
      "addedEvent": _vm.addedEvent
    }
  })], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelReservation
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (!_vm.isReschedule) ? [_c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button",
      "disabled": !_vm.buttonEnabled || _vm.isBooking
    },
    on: {
      "click": _vm.book
    }
  }, [_vm._v("Book")])] : [_c('button', {
    staticClass: "btn action wider",
    attrs: {
      "type": "button",
      "disabled": !_vm.buttonEnabled || _vm.isBooking
    },
    on: {
      "click": _vm.reschedule
    }
  }, [_vm._v("\n                Reschedule\n            ")])]], 2)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-fc3f3404", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc3f3404"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationAdd.vue
// module id = 1645
// module chunks = 0